export default class User {
    userID: string;
    name: string;
    email: string;
    settings?: { [key: string]: any };

    constructor(userID: string, name: string, email: string, settings?: { [key: string]: any }) {
        this.userID = userID;
        this.name = name;
        this.email = email;
        this.settings = settings;
    }
}
